/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 11/07/2019
 *
 * @version 0.2
 * Revisions:
 * 11/07/2019 - BW - Initial Creation
 * 06/13/2021 - BW - Modified: _onHelpNavLinkClick - added data for arg:"addFooter" to FALSE
 *
 * Description/Purpose:
 * Header Nav User
 * @publish PUBSUB_EVENT.CLOSE_HEADER_NAVIGATION
 ************************************************************** */

import ModalUtil from 'util/modal-util';
import EFile from "component/e-file/e-file";
import PUBSUB_EVENT from "constant/pubsub-event";
import PubSub from 'pubsub-js';


const HeaderNavUser = {
  _$allLink: $("#person_nav_list .nav-link:not('.nav-link-no-link')"),
  _$helpNavLink: $('#help_nav_link'),
  _$eFileNavLink: $('#e_file_nav_link'),
  _$logoutNavLink: $('#logout_nav_link'),


  /**
     * Init function
     * @param options
     * @returns {HeaderNavUser}
     */
  init(options) {
    const defaults = {};
    // extends config
    this.opts = $.extend(true, defaults, options);
    this._registerEvent();
    return this;
  },


  /**
     * Register events or DOM event
     * @private
     */
  _registerEvent() {
    //
    // First so the menu closes
    this._$allLink.on('click', ($event) => { PubSub.publish(PUBSUB_EVENT.CLOSE_HEADER_NAVIGATION); });
    // Must use bind so we can add a second click event
    this._$helpNavLink.on('click', ($event) => this._onHelpNavLinkClick($event));
    this._$eFileNavLink.on('click', ($event) => this._onEFileNavLinkClick($event));
    this._$logoutNavLink.on('click', ($event) => this._onLogoutLinkClick($event));
  },


  /**
     * Help Nav Link - Click Handler
     * @param $event
     * @private
     */
  _onHelpNavLinkClick($event) {
    ModalUtil.showCustomDisplayWindowModal($event, this._$helpNavLink, 'help-nav-link',
      true, true, true, 'Help', false);
  },


  /**
     * E-File Nav Link - Click Handler
     * @param $event
     * @private
     */
  _onEFileNavLinkClick($event) {
    EFile.init({ event: $event }).openAll();
  },


  /**
     * Logout Nav Link - Click Handler
     * @param $event
     * @private
     */
  _onLogoutLinkClick($event) {
    $event.preventDefault();
    window.location.replace(this._$logoutNavLink.attr('href'));
  },

};
export default HeaderNavUser;
